<template>
  <b-container fluid>
    <main-modal id="scheduleDetailsModal" size="lg">
      <template v-slot:header>
        <h4 class="font-weight-bold" v-if="typeOfModal == 'add'">
          <span class="text-warning">Add: </span> Flow Slots</h4>
        <h4 class="font-weight-bold" v-else><span class="text-info">Edit: </span> Slot</h4>
      </template>
      <template v-slot:actions v-if="typeOfModal == 'edit'">
        <div class="d-flex">
          <div class="modal-embed-actions cursor-pointer" @click="deleteSlot">
            <i class="las la-trash-alt text-danger font-size-20"></i>
          </div>
          <div class="modal-embed-actions">
            <div class="d-flex justify-content-between">
              <span class="text-info font-weight-bold font-size-12 mr-3">Active</span>
              <div
                  class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color mr-0">
                <div class="custom-switch-inner">
                  <input type="checkbox" class="custom-control-input bg-info" :id="'status'"
                         @change="changeStatus(scheduleDetails.id, scheduleDetails.status_traker)"
                         v-model="scheduleDetails.status_traker">
                  <label class="custom-control-label" :for="'status'">
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <schedule-details @addSlots="addSlots"
                          @editSlot="editSlot"
                          :requestLoading="requestLoading"
                          :scheduleDetails="scheduleDetails"
                          :allFlows="allFlows"
                          :typeOfModal="typeOfModal"/>
      </template>
    </main-modal>
      <section class="mb-4 d-flex justify-content-between align-items-center flex-wrap">
          <div><h3>Schedule</h3></div>
          <div>
            <ul class="levels-list m-0 p-0 justify-content-center">
              <li class="p-1" v-for="(level, key) in levels" :key="key">
                  <i class="fas fa-circle ml-3 mr-2" :style="{color : level.color}"></i>
                  <span class="font-size-12 text-uppercase">{{ level.name }}</span>
              </li>
          </ul>
      </div>
          <div>
              <div class="d-flex justify-content-md-end justify-content-center gap-20">
                  <b-button @click="clearSchedule" variant="dark" class="add_button text-white">
                      <span>Clear Schedule<i class="fas fa-trash-alt ml-3"></i></span>
                  </b-button>
                  <b-button @click="openPopup" variant="warning" class="add_button text-white">
                      Add Flow Slots<i class="fas fa-calendar-alt ml-3"></i></b-button>
              </div>
          </div>
      </section>
    <b-row>
      <spinner-loading v-if="requestLoading"></spinner-loading>
      <b-col lg="12" v-if="allSlots.length > 0">
        <b-card class="overflow-auto text-center schedule-card">
          <b-row class="flex-nowrap m-0">
            <b-col class="schedule-col px-0" v-for="(day, key) in days" :key="key">
              <h6 class="mb-3 pt-3 schedule-header">{{ day.key }}</h6>
              <div v-for="(slot, slotKey) in allSlots.filter((ele) => { return ele.day === day.value })"
                   :key="slotKey"
                   class="p-2 d-flex justify-content-center align-items-center cursor-pointer slot-box"
                   :style="(slot.status === 'active' || slot.service.status === true) ? { backgroundColor: getSlotColor(slot.service.level.color).bgColor } : { backgroundColor: '#a09e9e', color: 'black' }"
                   @click="showScheduleToEdit(slot)">
                <ul class="my-ul pl-0" :style="(slot.status === 'active' || slot.service.status === true) ? { color: slot.service.level.color } : { backgroundColor: '#a09e9e', color: 'black' }">
                  <li v-if="(slot.ladies_only)" class="ladies-only-tag">
                    <div class="ladies-only-container">
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.22226 4.04378C7.22226 4.3974 7.36274 4.73654 7.61278 4.98659C7.86283 5.23664 8.20197 5.37712 8.55559 5.37712C8.90922 5.37712 9.24835 5.23664 9.4984 4.98659C9.74845 4.73654 9.88893 4.3974 9.88893 4.04378C9.88893 3.69016 9.74845 3.35102 9.4984 3.10097C9.24835 2.85092 8.90922 2.71045 8.55559 2.71045C8.20197 2.71045 7.86283 2.85092 7.61278 3.10097C7.36274 3.35102 7.22226 3.69016 7.22226 4.04378Z" stroke="#FF7DAA" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.22228 15.3772V12.7105H5.88895L7.22228 8.71049C7.22228 8.53368 7.29252 8.36411 7.41754 8.23909C7.54257 8.11406 7.71214 8.04382 7.88895 8.04382H9.22228C9.39909 8.04382 9.56866 8.11406 9.69369 8.23909C9.81871 8.36411 9.88895 8.53368 9.88895 8.71049L11.2223 12.7105H9.88895V15.3772" stroke="#FF7DAA" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </li>
                  <li>{{ formatTime(slot.from) }} - {{ formatTime(slot.to) }}</li>
                  <li>{{ slot.service.name }}</li>
                  <li>
                      {{
                        slot.instructors
                            ?.slice(0, 3)
                            .map(i => i.first_name)
                            .filter(Boolean)
                            .join(', ')
                      }}

                    <span v-if="slot.instructors && slot.instructors.length > 4">
                      +{{ slot.instructors.length - 3 }}
                    </span>
                  </li>
                </ul>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-else-if="!requestLoading" md="12" class="text-center text-black">
        <b-card> No Available slots</b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import scheduleDetails from '@/modules/business/schedule/components/scheduleDetails'
import scheduleServices from '@/modules/business/schedule/services/schedule.sevices'
import calendarServices from '@/modules/business/calendar/services/calendar.sevices'
import mainService from '@/services/main'
import EventBus from '@/eventBus'
import settingsServices from '@/modules/superAdmin/settings/services/settings.services'

export default {
  data () {
    return {
      requestLoading: false,
      typeOfModal: 'add',
      scheduleDetails: {},
      scheduleId: '',
      allFlows: [],
      allSlots: [],
      levels: [],
      days: [
        {
          key: 'SUN',
          value: 'sunday'
        }, {
          key: 'MON',
          value: 'monday'
        }, {
          key: 'TUE',
          value: 'tuesday'
        }, {
          key: 'WED',
          value: 'wednesday'
        }, {
          key: 'THU',
          value: 'thursday'
        }, {
          key: 'FRI',
          value: 'friday'
        }, {
          key: 'SAT',
          value: 'saturday'
        }
      ],
      scheduleDetailsFront: {}
    }
  },
  components: {
    scheduleDetails
  },
  methods: {
    getColor (slot) {
      return this.levels.findIndex(l => l.value === slot.service.level.name.toLowerCase()) > -1 ? this.levels.find(l => l.value === slot.service.level.name.toLowerCase()).color : 'blue'
    },
    getSlotColor (hexa) {
      return {
        color: hexa,
        bgColor: core.hexToRgba(hexa, 0.4)
      }
    },
    openPopup () {
      this.scheduleId = ''
      this.typeOfModal = 'add'
      this.scheduleDetails = false
      this.$bvModal.show('scheduleDetailsModal')
    },
    addSlots (schedule) {
      this.requestLoading = true
      scheduleServices.setNewSlot(schedule).then(res => {
        core.showSnackbar('success', res.data.message)
        this.getSchedule()
        this.$bvModal.hide('scheduleDetailsModal')
      }).finally(() => {
        this.requestLoading = false
      })
    },
    editSlot (slotId, schedule) {
      this.requestLoading = true
      scheduleServices.editSchedule(slotId, schedule).then(res => {
        core.showSnackbar('success', res.data.message)
        this.getSchedule()
        this.$bvModal.hide('scheduleDetailsModal')
      }).finally(() => {
        this.requestLoading = false
      })
    },
    showScheduleToEdit (obj) {
      console.log('obj -> ', obj)
      this.typeOfModal = 'edit'
      this.scheduleDetailsFront = obj
      scheduleServices.getScheduleDetails(obj.id).then(res => {
        this.scheduleDetails = res.data.data
        this.scheduleDetails.status_traker = this.scheduleDetails.status === 'active'
        this.scheduleDetails.slotId = obj.id
        this.$bvModal.show('scheduleDetailsModal')
      })
    },
    getAllFlows () {
      this.requestLoading = true
      calendarServices.getAllServicesLimit().then(res => {
        this.allFlows = res.data.data.data
        this.requestLoading = false
      })
    },
    getSchedule () {
      this.requestLoading = true
      scheduleServices.getAllSlots().then(res => {
        this.allSlots = res.data.data.data
        this.requestLoading = false
      })
    },
    getAllLevel () {
      settingsServices.getAllLevels().then(response => {
        this.levels = [...response.data.data, {
          name: 'LADIES ONLY',
          color: 'pink'
        }
        ]
      })
    },
    deleteSlot () {
      EventBus.$emit('openDeleteModal', {
        actionHeader: 'Clear',
        titleHeader: 'Slot',
        textContent: `${this.scheduleDetailsFront.service.name} in ${this.scheduleDetailsFront.day} `,
        question: 'Are you sure you want to delete this slot from the schedule?',
        textDeleteButton: 'YES, Clear',
        textCancelButton: 'NO, CANCEL',
        icon: 'las la-trash-alt',
        type: 'delete',
        actionOnAlert: '',
        text: 'Clear',
        url: 'schedules',
        rowId: this.scheduleDetailsFront.id
      })
    },
    clearSchedule () {
      EventBus.$emit('openDeleteModal', {
        actionHeader: 'Delete',
        titleHeader: 'Schedule',
        textContent: 'Are you sure you want to delete all slots in the schedule?',
        question: '',
        textDeleteButton: 'YES, Delete',
        textCancelButton: 'NO, CANCEL',
        icon: 'las la-trash-alt',
        type: 'delete',
        actionOnAlert: '',
        text: 'Delete',
        url: 'clear-schedules',
        method: 'get'
      })
    },
    changeStatus (id, status) {
      const obj = {
        activity_id: id,
        status: status ? 'active' : 'inactive'
      }
      mainService.changeStatus(obj, 'schedule').then(res => {
        this.scheduleDetails.status = obj.status
        this.getSchedule()
        core.showSnackbar('success', res.data.message)
      }).catch(() => {
        this.scheduleDetails.status = !status
      })
    },
    formatTime (time) {
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
      time.splice(4)
      if (time.length > 1) {
        time = time.slice(1)
        time[5] = +time[0] < 12 ? ' AM' : ' PM'
        time[0] = +time[0] % 12 || 12
      }
      return time.join('')
    }
  },
  created () {
    this.getAllLevel()
    this.getSchedule()
    this.getAllFlows()
    EventBus.$on('reloadTableAfterDelete', ifReload => {
      this.$bvModal.hide('scheduleDetailsModal')
      this.getSchedule()
      core.showSnackbar('success', 'Data deleted successfully')
    })
  },
  beforeDestroy () {
  },
  mounted () {
    core.index()
  }
}
</script>
